export const Types = {
  GET_REQUEST: 'payments/GET_REQUEST',
  GET_SUCCESS: 'payments/GET_SUCCESS',
  GET_FAILURE: 'payments/GET_FAILURE',

  GET_LIST_REQUEST: 'payments/GET_LIST_REQUEST',
  GET_LIST_SUCCESS: 'payments/GET_LIST_SUCCESS',
  GET_LIST_FAILURE: 'payments/GET_LIST_FAILURE',

  CREATE_REQUEST: 'payments/CREATE_REQUEST',
  CREATE_SUCCESS: 'payments/CREATE_SUCCESS',
  CREATE_FAILURE: 'payments/CREATE_FAILURE',

  UPDATE_REQUEST: 'payments/UPDATE_REQUEST',
  UPDATE_SUCCESS: 'payments/UPDATE_SUCCESS',
  UPDATE_FAILURE: 'payments/UPDATE_FAILURE',

  DELETE_REQUEST: 'payments/DELETE_REQUEST',
  DELETE_SUCCESS: 'payments/DELETE_SUCCESS',
  DELETE_FAILURE: 'payments/DELETE_FAILURE',
};

const initialState = {
  data: [],
  loading: true,
  page: 1,
  totals: 1,

  detail: {
    data: {},
    loading: true,
  },

  create: {
    loading: false,
  },

  update: {
    loading: false,
  },

  delete: {
    loading: false,
  },
};

export default function payments(state = initialState, action) {
  switch (action.type) {
    case Types.GET_REQUEST:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: true,
        },
      };
    case Types.GET_SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: action.payload.payment.data,
        },
      };
    case Types.GET_FAILURE:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
        },
      };
    case Types.GET_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Types.GET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.payments.data,
        page: action.payload.payments.meta.current_page,
        totals: action.payload.payments.meta.total_pages,
      };
    case Types.GET_LIST_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case Types.CREATE_REQUEST:
      return {
        ...state,
        create: {
          ...state.create,
          loading: true,
        },
      };
    case Types.CREATE_SUCCESS:
    case Types.CREATE_FAILURE:
      return {
        ...state,
        create: {
          ...state.create,
          loading: false,
        },
      };
    case Types.UPDATE_REQUEST:
      return {
        ...state,
        update: {
          ...state.update,
          loading: true,
        },
      };
    case Types.UPDATE_SUCCESS:
    case Types.UPDATE_FAILURE:
      return {
        ...state,
        update: {
          ...state.update,
          loading: false,
        },
      };
    case Types.DELETE_REQUEST:
      return {
        ...state,
        delete: {
          ...state.delete,
          loading: true,
        },
      };
    case Types.DELETE_SUCCESS:
    case Types.DELETE_FAILURE:
      return {
        ...state,
        delete: {
          ...state.delete,
          loading: false,
        },
      };
    default:
      return state;
  }
}

export const Creators = {
  getPaymentRequest: id => ({
    type: Types.GET_REQUEST,
    payload: { id },
  }),

  getPaymentSuccess: payment => ({
    type: Types.GET_SUCCESS,
    payload: { payment },
  }),

  getPaymentFailure: () => ({
    type: Types.GET_FAILURE,
  }),

  getPaymentsRequest: (page = 1) => ({
    type: Types.GET_LIST_REQUEST,
    payload: { page },
  }),

  getPaymentsSuccess: payments => ({
    type: Types.GET_LIST_SUCCESS,
    payload: { payments },
  }),

  getPaymentsFailure: () => ({
    type: Types.GET_LIST_FAILURE,
  }),

  createPaymentRequest: data => ({
    type: Types.CREATE_REQUEST,
    payload: { data },
  }),

  createPaymentSuccess: () => ({
    type: Types.CREATE_SUCCESS,
  }),

  createPaymentFailure: () => ({
    type: Types.CREATE_FAILURE,
  }),

  updatePaymentRequest: (id, data) => ({
    type: Types.UPDATE_REQUEST,
    payload: { id, data },
  }),

  updatePaymentSuccess: () => ({
    type: Types.UPDATE_SUCCESS,
  }),

  updatePaymentFailure: () => ({
    type: Types.UPDATE_FAILURE,
  }),

  deletePaymentRequest: id => ({
    type: Types.DELETE_REQUEST,
    payload: { id },
  }),

  deletePaymentSuccess: () => ({
    type: Types.DELETE_SUCCESS,
  }),

  deletePaymentFailure: () => ({
    type: Types.DELETE_FAILURE,
  }),
};
